import Button from "@ingka/button";
import Modal, { Prompt, ModalFooter , ModalHeader} from "@ingka/modal"; 
import React, { useState } from "react";

const OpenMyIdentityDialog = ({errorTitle, errorDescription}) => {
   const [modalOpen, setModalOpen] = useState(true)
  
  return (
    <Modal 
          visible={modalOpen} 
          focusLockProps={focus}
          handleCloseBtn={() => {setModalOpen(false); window.location.assign("/");}} 
        >
          <Prompt
            title={errorTitle} 
            header={<ModalHeader />}
            footer={
              <ModalFooter>
                <Button text="Open MyIdentity" type="primary" onClick={()=>{window.open("https://myidentity.apps.ikea.com/", "_blank"); window.location.assign("/");}}/>
                <Button text="Close" type="secondary" onClick={() => window.location.assign("/")}/>
              </ModalFooter>
            }>
            <p>{errorDescription}</p>
          </Prompt>
        </Modal>
  );
};

export default OpenMyIdentityDialog;
const focus = {
  returnFocus: false,
  autoFocus: false
};
